import { render, staticRenderFns } from "./AddUserForBuilding.vue?vue&type=template&id=28542453&"
import script from "./AddUserForBuilding.vue?vue&type=script&lang=js&"
export * from "./AddUserForBuilding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports